// extracted by mini-css-extract-plugin
export default {"page":"p3-z","cartModal":"q3-z","checkout":"r3-z","placeholder":"s3-z","account":"t3-z"};